import React, { Component } from 'react';
import {
  Text,
  View,
  Dimensions,
  TouchableOpacity,
  Alert,
} from '../src/web/react-native';
import { createMaterialTopTabNavigator } from '../src/navigation/topTabs';
import TeamLogs from './TeamLogs';
import Service from './../Service/service';
import MyPost from './MyPosts/MyPost';
import { connect } from 'react-redux';
import { GetShiftLogsActionAsync, GetTeamShiftLogsActionAsync } from './../Action/ShiftLogAction';
import { GetPreferenceActionAsync } from './../Action/PreferenceAction';
import { LoadingOverlay } from '../src/components';
import Modal from '../src/components/BaseModal';
import Menu from './Menu/menu';
import NetInfo from '../src/services/netinfo';
import { NavBar, NavIconButton, FabButton } from '../src/components';
import { Route } from '../src/app/Route';
import { DdLogs } from '../src/logging/datadog';

export class Report extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuVisible: false,
      isOnline: true,
      width: Dimensions.get('window').width,
      height: Dimensions.get('window').height,
    };
  }
  async componentDidMount() {
    this.isMountedReport = true;
    this.netInfoUnsubscribe = NetInfo.addEventListener((state) => {
      if (state.isConnected == true) {
        this.setState({ isOnline: true });
        DdLogs.info('online');
      } else {
        this.setState({ isOnline: false });
        DdLogs.info('offline');
      }
    });
    Dimensions.addEventListener('change', () => {
      this.setState({
        width: Dimensions.get('window').width,
        height: Dimensions.get('window').height,
      });
    });
    NetInfo.fetch().then((state) => {
      if (!this.isMountedReport) return;
      if (state.isConnected == true) {
        this.setState({ isOnline: true });
        if (!this.props.route.params) {
          this.fetchPreference();
          this.fetchShiftLogs(0);
        }
      } else {
        this.setState({ isOnline: false });
        setTimeout(() => {
          if (this.isMountedReport) {
            Alert.alert('Error', 'No connection, please check your network settings.');
          }
        }, 200);
      }
    });
  }
  componentWillUnmount() {
    this.isMountedReport = false;
    this.netInfoUnsubscribe?.();
  }
  showFetchError = (error, message) => {
    if (!this.isMountedReport || error?.code === 'ERR_CANCELED') return;
    DdLogs.error(message, error);
    setTimeout(() => {
      if (this.isMountedReport) Alert.alert('Error', message);
    }, 200);
  };

  fetchShiftLogs = async (index) => {
    try {
      const localPreference = await Service.getLocalPreferences();
      if (!this.isMountedReport) return;
      if (index == 0) {
        await this.props.GetShiftLogs(localPreference);
      } else {
        await this.props.GetTeamShiftLogs(localPreference);
      }
    } catch (error) {
      this.showFetchError(
        error,
        index == 0
          ? 'Unable to fetch shift logs, please try again later.'
          : 'Unable to get team shift logs, please try again later.',
      );
    }
  };

  fetchPreference = async () => {
    try {
      const localPreference = await Service.getLocalPreferences();
      if (!this.isMountedReport) return;
      await this.props.GetPreference(localPreference);
    } catch (err) {
      if (!this.isMountedReport || err?.code === 'ERR_CANCELED') return;
      DdLogs.error('report.js fetch preference error...', err);
    }
  };
  setMenuVisible = (isVisible) => {
    this.setState({
      isMenuVisible: isVisible,
    });
  };
  render() {
    const width = this.state.width;
    let height = Math.max(this.state.height, width);
    //  height = 1000;
    const Tab = createMaterialTopTabNavigator();
    return (
      <View style={{ flex: 1 }}>
        {/*************     Activity Indicator      *************/}
        {<LoadingOverlay visible={this.props.loadingShiftLogs} />}

        {/*************     Menu Modal      *************/}
        <View style={{ flex: 1 }} contentContainerStyle={{ height: height }}>
          <Modal
            isVisible={this.state.isMenuVisible}
            swipeDirection={['left']}
            onSwipeComplete={() => this.setState({ isMenuVisible: false })}
            animationIn="slideInLeft"
            animationOut="slideOutLeft"
            style={{ margin: 0 }}
            onBackdropPress={() => this.setState({ isMenuVisible: false })}>
            <View style={{ flex: 1, flexDirection: 'row' }}>
              <Menu propsCarryover={this.props} setMenuVisible={this.setMenuVisible}></Menu>
              <TouchableOpacity
                activeOpacity={1}
                onPress={() => this.setState({ isMenuVisible: false })}
                style={{ flex: 1 }}
              />
            </View>
          </Modal>

          {/*************     Navigation Bar      *************/}
          <NavBar
            title="Log Reports"
            leftButton={
              <NavIconButton
                icon={'menu'}
                onPress={() => {
                  this.setState({
                    isMenuVisible: true,
                  });
                }}
              />
            }
            rightButton={
              <NavIconButton
                icon={'refresh'}
                onPress={() => {
                  const tabIndex = this.props?.route?.state?.index ?? 0;
                  if (!('state' in this.props.route)) {
                    this.fetchPreference();
                  }
                  this.fetchShiftLogs(tabIndex);
                }}
              />
            }
          />
          {/*************     Segment Control      *************/}
          <View
            style={{
              flex: 8,
              backgroundColor: '#f3f7fa',
              alignItems: 'center',
            }}>
            <View style={{ flex: 1, width: width, backgroundColor: '#fff' }}>
              <Tab.Navigator
                initialRouteName={Route.myPost}
                tabBar={(props) => {
                  return <TabStatusBar props={props} _this={this} />;
                }}
                style={{ flex: 1 }}>
                <Tab.Screen
                  name={Route.myPost}
                  component={MyPost}
                  initialParams={{
                    isTeamLog: false,
                  }}
                  options={{ title: 'My Post' }}
                />
                <Tab.Screen
                  name={Route.teamLogs}
                  component={TeamLogs}
                  initialParams={{ isTeamLog: true }}
                  options={{ title: 'Team Logs' }}
                />
              </Tab.Navigator>
            </View>
          </View>
        </View>
        <FabButton
          label="New Log"
          onPress={() =>
            //TODO: refactor the way route state is being pulled
            this.props.navigation.navigate(Route.createShiftLogScreen, {
              isTeamLog: this.props?.route?.state?.index === 1,
            })
          }
          icon="plus"
        />
      </View>
    );
  }
}
function TabStatusBar({ props, _this }) {
  let { state, descriptors, navigation, position, route } = { ...props };
  const width = Dimensions.get('window').width;
  // console.log(_this._refresh)
  return (
    <View
      style={{
        marginHorizontal: 20,
        marginVertical: 5,
        backgroundColor: '#7676801F',
        borderRadius: 10,
        height: 40,
      }}>
      <View style={{ flex: 1, flexDirection: 'row' }}>
        {state.routes.map((route, index) => {
          const { options } = descriptors[route.key];
          let isFocused = state.index === index;
          const onPress = () => {
            const event = navigation.emit({
              type: 'tabPress',
              target: route.key,
            });

            if (!isFocused && !event.defaultPrevented) {
              _this.fetchShiftLogs(index);
              navigation.navigate(route.name, {
                isTeamLog: index,
              });
            }
          };

          // modify inputRange for custom behavior
          const inputRange = state.routes.map((_, i) => i);

          return (
            <TouchableOpacity
              accessibilityLabel={options.tabBarAccessibilityLabel}
              testID={options.tabBarTestID}
              onPress={onPress}
              key={route.key}
              // ref={(e) => _this._refresh = e}
            >
              <View
                style={[
                  { margin: 5, width: (0.9 * width) / 2 - 10, height: 30 },
                  getTextStyle(width, index, state.routes.length, isFocused),
                ]}>
                <Text style={{ lineHeight: 30, textAlign: 'center' }}>{options.title}</Text>
              </View>
            </TouchableOpacity>
          );
        })}
      </View>
    </View>
  );
}
function getTextStyle(width, index, length, isFocused) {
  let selected = {};
  if (isFocused) {
    selected = { backgroundColor: '#fff' };
  }

  if (index == 0) {
    return {
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: 10,
      ...selected,
    };
  } else if (index == length - 1) {
    return {
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: 10,
      ...selected,
    };
  } else {
    return {
      justifyContent: 'center',
      alignItems: 'center',
      ...selected,
    };
  }
}
const mapStateToProps = (state) => ({
  // shiftLogs: state.ShiftLogsReducer.shiftLogs,
  preference: state.preference.preferences,
  loadingShiftLogs: state.shiftLogs.isLoading,
});
const mapDispatchToProps = (dispatch) => {
  return {
    GetShiftLogs: (preference, params) => {
      return dispatch(
        GetShiftLogsActionAsync({
          siteCode: preference.site.siteCode,
          assetName: Service.getShiftLogAssetName(preference),
        }),
      );
    },
    GetTeamShiftLogs: (preference) => {
      return dispatch(
        GetTeamShiftLogsActionAsync({
          siteCode: preference.site.siteCode,
          assetName: Service.getShiftLogAssetName(preference),
        }),
      );
    },
    GetPreference: (preference) => {
      return dispatch(GetPreferenceActionAsync(preference.site.siteCode));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Report);